/* ═══════════════════════════════════════════════════════════════════════════
   THE CATALOGUE — every demo business, every industry

   Generated from the prototype (v25) by tools/catalogue.py. Not one value is
   invented: names, addresses, organisation numbers, opening hours, price
   lists, ratings and review counts are exactly what stands in the prototype,
   which is the specification the sales demo was built from.

   Staff names for the businesses the prototype did not name are produced by
   its own deterministic picker (bHash/bPick, ported line for line), so the
   same business always shows the same people.

   The values stay Norwegian on purpose. Business names, addresses, price
   lists and staff roles are real-world facts about real businesses — the code
   is English, what a salon calls a haircut is not ours to translate.

   `lat`/`lng` are the prototype's own coordinates, kept because the front page
   measures distance with them — see domain/nearby.js. There is no map service
   involved and no key to obtain: the arithmetic is Haversine on two numbers
   that were already in the data.

   Two businesses were moved out of the prototype's `home` bucket into the
   industry they actually are: Skadestopp is restoration, CleanShine is
   cleaning. The prototype had no code for those; the registry does.

   This is temporary. When Chamcore answers for real, the same fields come
   from there and this file is left as a fixture for the tests.
   ═══════════════════════════════════════════════════════════════════════ */

export const BUSINESSES = [
  {
    "id": "lykke",
    "lat": 59.9276,
    "lng": 10.718,
    "slug": "lykke",
    "name": "Lykke Salong",
    "logo": [
      "LYKKE",
      "SALONG"
    ],
    "mark": "L",
    "industry": "hair",
    "city": "Oslo",
    "street": "Bogstadveien 10, 0272 Oslo",
    "org_no": "917 442 006",
    "founded": 2016,
    "phone": "22 60 60 60",
    "email": "post@lykkesalong.no",
    "website": "lykkesalong.no",
    "opening_hours": "Man–fre 09:00–18:00, lør 10:00–16:00",
    "tagline": "Klipp, farge og styling i Bogstadveien. Vi tar oss tid til konsultasjon før hver behandling.",
    "from": "590 kr",
    "rating": 4.9,
    "reviews": 128,
    "t1": "Finn frisøren.",
    "t2": "Book i dag.",
    "eyebrow": "FRISØR & BARBER · OSLO",
    "staff_count": 8,
    "services": [
      {
        "name": "Klipp",
        "description": "Vask, klipp og enkel styling.",
        "priceText": "fra 590 kr",
        "unit": "45 min",
        "icon": "user",
        "price": 590
      },
      {
        "name": "Farge & striper",
        "description": "Konsultasjon, farge og avsluttende styling.",
        "priceText": "fra 1 490 kr",
        "unit": "120 min",
        "icon": "star",
        "price": 1490
      },
      {
        "name": "Styling",
        "description": "Oppsett til fest, bryllup eller foto.",
        "priceText": "fra 890 kr",
        "unit": "60 min",
        "icon": "star",
        "price": 890
      },
      {
        "name": "Barber",
        "description": "Klipp og skjeggtrim.",
        "priceText": "fra 490 kr",
        "unit": "45 min",
        "icon": "user",
        "price": 490
      }
    ]
  },
  {
    "id": "northbarber",
    "lat": 59.9295,
    "lng": 10.7145,
    "slug": "northbarber",
    "name": "North Barber",
    "logo": [
      "NORTH",
      "BARBER"
    ],
    "mark": "N",
    "industry": "hair",
    "city": "Oslo",
    "street": "Valkyriegata 9, 0366 Oslo",
    "org_no": "922 108 774",
    "founded": 2019,
    "phone": "22 46 10 10",
    "email": "hei@northbarber.no",
    "website": "northbarber.no",
    "opening_hours": "Man–fre 10:00–19:00, lør 10:00–16:00",
    "tagline": "Klassisk barbering, skjeggtrim og herreklipp på Majorstuen. Drop-in og booking.",
    "from": "490 kr",
    "rating": 4.9,
    "reviews": 211,
    "t1": "Finn frisøren.",
    "t2": "Book i dag.",
    "eyebrow": "FRISØR & BARBER · OSLO",
    "staff_count": 5,
    "services": [
      {
        "name": "Klipp",
        "description": "Vask, klipp og enkel styling.",
        "priceText": "fra 590 kr",
        "unit": "45 min",
        "icon": "user",
        "price": 590
      },
      {
        "name": "Farge & striper",
        "description": "Konsultasjon, farge og avsluttende styling.",
        "priceText": "fra 1 490 kr",
        "unit": "120 min",
        "icon": "star",
        "price": 1490
      },
      {
        "name": "Styling",
        "description": "Oppsett til fest, bryllup eller foto.",
        "priceText": "fra 890 kr",
        "unit": "60 min",
        "icon": "star",
        "price": 890
      },
      {
        "name": "Barber",
        "description": "Klipp og skjeggtrim.",
        "priceText": "fra 490 kr",
        "unit": "45 min",
        "icon": "user",
        "price": 490
      }
    ]
  },
  {
    "id": "stilhus",
    "lat": 60.3948,
    "lng": 5.321,
    "slug": "stilhus",
    "name": "Stilhus Frisør",
    "logo": [
      "STILHUS",
      "FRISØR"
    ],
    "mark": "S",
    "industry": "hair",
    "city": "Bergen",
    "street": "Strandgaten 18, 5013 Bergen",
    "org_no": "996 331 220",
    "founded": 2011,
    "phone": "55 32 18 00",
    "email": "post@stilhus.no",
    "website": "stilhus.no",
    "opening_hours": "Man–fre 09:00–18:00, lør 10:00–15:00",
    "tagline": "Farge og balayage i sentrum av Bergen. Spesialister på lyse toner og hårkvalitet.",
    "from": "620 kr",
    "rating": 4.7,
    "reviews": 96,
    "t1": "Finn frisøren.",
    "t2": "Book i dag.",
    "eyebrow": "FRISØR & BARBER · BERGEN",
    "staff_count": 6,
    "services": [
      {
        "name": "Klipp",
        "description": "Vask, klipp og enkel styling.",
        "priceText": "fra 590 kr",
        "unit": "45 min",
        "icon": "user",
        "price": 590
      },
      {
        "name": "Farge & striper",
        "description": "Konsultasjon, farge og avsluttende styling.",
        "priceText": "fra 1 490 kr",
        "unit": "120 min",
        "icon": "star",
        "price": 1490
      },
      {
        "name": "Styling",
        "description": "Oppsett til fest, bryllup eller foto.",
        "priceText": "fra 890 kr",
        "unit": "60 min",
        "icon": "star",
        "price": 890
      },
      {
        "name": "Barber",
        "description": "Klipp og skjeggtrim.",
        "priceText": "fra 490 kr",
        "unit": "45 min",
        "icon": "user",
        "price": 490
      }
    ]
  },
  {
    "id": "klipperiet",
    "lat": 63.4322,
    "lng": 10.396,
    "slug": "klipperiet",
    "name": "Klipperiet Trondheim",
    "logo": [
      "KLIPPERIET",
      "TRONDHEIM"
    ],
    "mark": "K",
    "industry": "hair",
    "city": "Trondheim",
    "street": "Nordre gate 11, 7011 Trondheim",
    "org_no": "991 774 508",
    "founded": 2008,
    "phone": "73 52 40 40",
    "email": "post@klipperiet.no",
    "website": "klipperiet.no",
    "opening_hours": "Man–fre 09:00–19:00, lør 10:00–16:00",
    "tagline": "Familiesalong midt i byen. Egne priser for barn, student og honnør.",
    "from": "540 kr",
    "rating": 4.6,
    "reviews": 154,
    "t1": "Finn frisøren.",
    "t2": "Book i dag.",
    "eyebrow": "FRISØR & BARBER · TRONDHEIM",
    "staff_count": 9,
    "services": [
      {
        "name": "Klipp",
        "description": "Vask, klipp og enkel styling.",
        "priceText": "fra 590 kr",
        "unit": "45 min",
        "icon": "user",
        "price": 590
      },
      {
        "name": "Farge & striper",
        "description": "Konsultasjon, farge og avsluttende styling.",
        "priceText": "fra 1 490 kr",
        "unit": "120 min",
        "icon": "star",
        "price": 1490
      },
      {
        "name": "Styling",
        "description": "Oppsett til fest, bryllup eller foto.",
        "priceText": "fra 890 kr",
        "unit": "60 min",
        "icon": "star",
        "price": 890
      },
      {
        "name": "Barber",
        "description": "Klipp og skjeggtrim.",
        "priceText": "fra 490 kr",
        "unit": "45 min",
        "icon": "user",
        "price": 490
      }
    ]
  },
  {
    "id": "atelier",
    "lat": 59.9236,
    "lng": 10.728,
    "slug": "atelier",
    "name": "Atelier Beauty",
    "logo": [
      "ATELIER",
      "BEAUTY"
    ],
    "mark": "A",
    "industry": "beauty",
    "city": "Oslo",
    "street": "Hegdehaugsveien 31, 0352 Oslo",
    "org_no": "920 554 118",
    "founded": 2018,
    "phone": "22 40 44 40",
    "email": "post@atelierbeauty.no",
    "website": "atelierbeauty.no",
    "opening_hours": "Man–fre 10:00–19:00, lør 10:00–16:00",
    "tagline": "Hud, bryn og negler på Hegdehaugsveien. Alle hudbehandlinger starter med gratis analyse.",
    "from": "490 kr",
    "rating": 4.9,
    "reviews": 174,
    "t1": "Beauty på dine",
    "t2": "premisser.",
    "eyebrow": "HUD, NEGLER & BEAUTY · OSLO",
    "staff_count": 7,
    "services": [
      {
        "name": "Hudbehandling",
        "description": "Rens, peeling og pleie tilpasset huden din.",
        "priceText": "fra 990 kr",
        "unit": "60 min",
        "icon": "star",
        "price": 990
      },
      {
        "name": "Gelé negler",
        "description": "Nytt sett eller påfyll med valgfri finish.",
        "priceText": "fra 690 kr",
        "unit": "90 min",
        "icon": "star",
        "price": 690
      },
      {
        "name": "Bryn & vipper",
        "description": "Forming, farge og laminering.",
        "priceText": "fra 490 kr",
        "unit": "45 min",
        "icon": "user",
        "price": 490
      },
      {
        "name": "Voksing",
        "description": "Rask og skånsom behandling.",
        "priceText": "fra 350 kr",
        "unit": "30 min",
        "icon": "user",
        "price": 350
      }
    ]
  },
  {
    "id": "skinclinic",
    "lat": 59.9179,
    "lng": 10.7091,
    "slug": "skinclinic",
    "name": "SkinClinic Oslo",
    "logo": [
      "SKINCLINIC",
      "OSLO"
    ],
    "mark": "S",
    "industry": "beauty",
    "city": "Oslo",
    "street": "Frognerveien 12, 0257 Oslo",
    "org_no": "912 887 004",
    "founded": 2013,
    "phone": "22 12 90 90",
    "email": "post@skinclinic.no",
    "website": "skinclinic.no",
    "opening_hours": "Man–fre 09:00–17:00",
    "tagline": "Medisinsk hudpleie med autoriserte hudterapeuter. Konsultasjon før alle behandlinger.",
    "from": "690 kr",
    "rating": 4.8,
    "reviews": 67,
    "t1": "Beauty på dine",
    "t2": "premisser.",
    "eyebrow": "HUD, NEGLER & BEAUTY · OSLO",
    "staff_count": 5,
    "services": [
      {
        "name": "Hudbehandling",
        "description": "Rens, peeling og pleie tilpasset huden din.",
        "priceText": "fra 990 kr",
        "unit": "60 min",
        "icon": "star",
        "price": 990
      },
      {
        "name": "Gelé negler",
        "description": "Nytt sett eller påfyll med valgfri finish.",
        "priceText": "fra 690 kr",
        "unit": "90 min",
        "icon": "star",
        "price": 690
      },
      {
        "name": "Bryn & vipper",
        "description": "Forming, farge og laminering.",
        "priceText": "fra 490 kr",
        "unit": "45 min",
        "icon": "user",
        "price": 490
      },
      {
        "name": "Voksing",
        "description": "Rask og skånsom behandling.",
        "priceText": "fra 350 kr",
        "unit": "30 min",
        "icon": "user",
        "price": 350
      }
    ]
  },
  {
    "id": "luxenails",
    "lat": 59.9288,
    "lng": 10.7162,
    "slug": "luxenails",
    "name": "Luxe Nails & Beauty",
    "logo": [
      "LUXE",
      "NAILS & BEAUTY"
    ],
    "mark": "L",
    "industry": "beauty",
    "city": "Oslo",
    "street": "Bogstadveien 41, 0366 Oslo",
    "org_no": "925 663 471",
    "founded": 2020,
    "phone": "22 69 22 22",
    "email": "hei@luxenails.no",
    "website": "luxenails.no",
    "opening_hours": "Man–søn 10:00–20:00",
    "tagline": "Negler, bryn og vipper med korte ventetider. Drop-in når vi har ledig.",
    "from": "390 kr",
    "rating": 4.9,
    "reviews": 243,
    "t1": "Beauty på dine",
    "t2": "premisser.",
    "eyebrow": "HUD, NEGLER & BEAUTY · OSLO",
    "staff_count": 6,
    "services": [
      {
        "name": "Hudbehandling",
        "description": "Rens, peeling og pleie tilpasset huden din.",
        "priceText": "fra 990 kr",
        "unit": "60 min",
        "icon": "star",
        "price": 990
      },
      {
        "name": "Gelé negler",
        "description": "Nytt sett eller påfyll med valgfri finish.",
        "priceText": "fra 690 kr",
        "unit": "90 min",
        "icon": "star",
        "price": 690
      },
      {
        "name": "Bryn & vipper",
        "description": "Forming, farge og laminering.",
        "priceText": "fra 490 kr",
        "unit": "45 min",
        "icon": "user",
        "price": 490
      },
      {
        "name": "Voksing",
        "description": "Rask og skånsom behandling.",
        "priceText": "fra 350 kr",
        "unit": "30 min",
        "icon": "user",
        "price": 350
      }
    ]
  },
  {
    "id": "husetbeauty",
    "lat": 58.97,
    "lng": 5.7331,
    "slug": "husetbeauty",
    "name": "Huset Hudpleie",
    "logo": [
      "HUSET",
      "HUDPLEIE"
    ],
    "mark": "H",
    "industry": "beauty",
    "city": "Stavanger",
    "street": "Kirkegata 22, 4006 Stavanger",
    "org_no": "915 220 663",
    "founded": 2015,
    "phone": "51 89 30 30",
    "email": "post@husethudpleie.no",
    "website": "husethudpleie.no",
    "opening_hours": "Tir–fre 10:00–18:00, lør 10:00–15:00",
    "tagline": "Rolig klinikk i Stavanger sentrum. Hudpleie, voksing og bryn.",
    "from": "590 kr",
    "rating": 4.8,
    "reviews": 81,
    "t1": "Beauty på dine",
    "t2": "premisser.",
    "eyebrow": "HUD, NEGLER & BEAUTY · STAVANGER",
    "staff_count": 4,
    "services": [
      {
        "name": "Hudbehandling",
        "description": "Rens, peeling og pleie tilpasset huden din.",
        "priceText": "fra 990 kr",
        "unit": "60 min",
        "icon": "star",
        "price": 990
      },
      {
        "name": "Gelé negler",
        "description": "Nytt sett eller påfyll med valgfri finish.",
        "priceText": "fra 690 kr",
        "unit": "90 min",
        "icon": "star",
        "price": 690
      },
      {
        "name": "Bryn & vipper",
        "description": "Forming, farge og laminering.",
        "priceText": "fra 490 kr",
        "unit": "45 min",
        "icon": "user",
        "price": 490
      },
      {
        "name": "Voksing",
        "description": "Rask og skånsom behandling.",
        "priceText": "fra 350 kr",
        "unit": "30 min",
        "icon": "user",
        "price": 350
      }
    ]
  },
  {
    "id": "harmony",
    "lat": 59.9192,
    "lng": 10.704,
    "slug": "harmony",
    "name": "Harmony Spa",
    "logo": [
      "HARMONY",
      "SPA"
    ],
    "mark": "H",
    "industry": "massage",
    "city": "Oslo",
    "street": "Frognerveien 44, 0266 Oslo",
    "org_no": "913 664 221",
    "founded": 2014,
    "phone": "22 55 88 00",
    "email": "post@harmonyspa.no",
    "website": "harmonyspa.no",
    "opening_hours": "Man–fre 09:00–21:00, lør 10:00–18:00",
    "tagline": "Massasje og spa på Frogner. Fem behandlingsrom og egen hvilesone.",
    "from": "890 kr",
    "rating": 4.8,
    "reviews": 194,
    "t1": "Tid til å",
    "t2": "puste ut.",
    "eyebrow": "MASSASJE & VELVÆRE · OSLO",
    "staff_count": 9,
    "services": [
      {
        "name": "Massasje 60 min",
        "description": "Klassisk avspennende massasje.",
        "priceText": "fra 890 kr",
        "unit": "60 min",
        "icon": "user",
        "price": 890
      },
      {
        "name": "Dyp muskelbehandling",
        "description": "Målrettet mot nakke, skulder og rygg.",
        "priceText": "fra 1 090 kr",
        "unit": "75 min",
        "icon": "star",
        "price": 1090
      },
      {
        "name": "Idrettsmassasje",
        "description": "Restitusjon før eller etter konkurranse.",
        "priceText": "fra 990 kr",
        "unit": "60 min",
        "icon": "star",
        "price": 990
      },
      {
        "name": "Spa-pakke",
        "description": "Massasje, ansiktsbehandling og hvile.",
        "priceText": "fra 1 890 kr",
        "unit": "120 min",
        "icon": "star",
        "price": 1890
      }
    ]
  },
  {
    "id": "muskelverk",
    "lat": 59.9186,
    "lng": 10.7513,
    "slug": "muskelverk",
    "name": "Muskelverket",
    "logo": [
      "MUSKELVERKET",
      "MASSASJE & VELVÆRE"
    ],
    "mark": "M",
    "industry": "massage",
    "city": "Oslo",
    "street": "Torggata 31, 0183 Oslo",
    "org_no": "918 442 990",
    "founded": 2017,
    "phone": "22 11 66 44",
    "email": "post@muskelverket.no",
    "website": "muskelverket.no",
    "opening_hours": "Man–fre 07:00–20:00",
    "tagline": "Idretts- og muskelbehandling for aktive. Terapeuter med idrettsfaglig bakgrunn.",
    "from": "790 kr",
    "rating": 4.9,
    "reviews": 132,
    "t1": "Tid til å",
    "t2": "puste ut.",
    "eyebrow": "MASSASJE & VELVÆRE · OSLO",
    "staff_count": 4,
    "services": [
      {
        "name": "Massasje 60 min",
        "description": "Klassisk avspennende massasje.",
        "priceText": "fra 890 kr",
        "unit": "60 min",
        "icon": "user",
        "price": 890
      },
      {
        "name": "Dyp muskelbehandling",
        "description": "Målrettet mot nakke, skulder og rygg.",
        "priceText": "fra 1 090 kr",
        "unit": "75 min",
        "icon": "star",
        "price": 1090
      },
      {
        "name": "Idrettsmassasje",
        "description": "Restitusjon før eller etter konkurranse.",
        "priceText": "fra 990 kr",
        "unit": "60 min",
        "icon": "star",
        "price": 990
      },
      {
        "name": "Spa-pakke",
        "description": "Massasje, ansiktsbehandling og hvile.",
        "priceText": "fra 1 890 kr",
        "unit": "120 min",
        "icon": "star",
        "price": 1890
      }
    ]
  },
  {
    "id": "roro",
    "lat": 60.3878,
    "lng": 5.3235,
    "slug": "roro",
    "name": "Ro & Ro Velvære",
    "logo": [
      "RO",
      "& RO VELVÆRE"
    ],
    "mark": "R",
    "industry": "massage",
    "city": "Bergen",
    "street": "Håkonsgaten 27, 5015 Bergen",
    "org_no": "998 220 774",
    "founded": 2012,
    "phone": "55 20 11 11",
    "email": "post@roogro.no",
    "website": "roogro.no",
    "opening_hours": "Man–lør 10:00–20:00",
    "tagline": "Spa og massasje med utsikt over Bergen. Egne pakker for par.",
    "from": "850 kr",
    "rating": 4.7,
    "reviews": 88,
    "t1": "Tid til å",
    "t2": "puste ut.",
    "eyebrow": "MASSASJE & VELVÆRE · BERGEN",
    "staff_count": 6,
    "services": [
      {
        "name": "Massasje 60 min",
        "description": "Klassisk avspennende massasje.",
        "priceText": "fra 890 kr",
        "unit": "60 min",
        "icon": "user",
        "price": 890
      },
      {
        "name": "Dyp muskelbehandling",
        "description": "Målrettet mot nakke, skulder og rygg.",
        "priceText": "fra 1 090 kr",
        "unit": "75 min",
        "icon": "star",
        "price": 1090
      },
      {
        "name": "Idrettsmassasje",
        "description": "Restitusjon før eller etter konkurranse.",
        "priceText": "fra 990 kr",
        "unit": "60 min",
        "icon": "star",
        "price": 990
      },
      {
        "name": "Spa-pakke",
        "description": "Massasje, ansiktsbehandling og hvile.",
        "priceText": "fra 1 890 kr",
        "unit": "120 min",
        "icon": "star",
        "price": 1890
      }
    ]
  },
  {
    "id": "nordlys",
    "lat": 69.6512,
    "lng": 18.956,
    "slug": "nordlys",
    "name": "Nordlys Massasje",
    "logo": [
      "NORDLYS",
      "MASSASJE"
    ],
    "mark": "N",
    "industry": "massage",
    "city": "Tromsø",
    "street": "Storgata 74, 9008 Tromsø",
    "org_no": "923 118 002",
    "founded": 2019,
    "phone": "77 60 20 20",
    "email": "post@nordlysmassasje.no",
    "website": "nordlysmassasje.no",
    "opening_hours": "Man–fre 10:00–21:00, lør 11:00–17:00",
    "tagline": "Klassisk og dyp massasje i Tromsø sentrum. Kveldstimer hele uken.",
    "from": "790 kr",
    "rating": 4.9,
    "reviews": 57,
    "t1": "Tid til å",
    "t2": "puste ut.",
    "eyebrow": "MASSASJE & VELVÆRE · TROMSØ",
    "staff_count": 3,
    "services": [
      {
        "name": "Massasje 60 min",
        "description": "Klassisk avspennende massasje.",
        "priceText": "fra 890 kr",
        "unit": "60 min",
        "icon": "user",
        "price": 890
      },
      {
        "name": "Dyp muskelbehandling",
        "description": "Målrettet mot nakke, skulder og rygg.",
        "priceText": "fra 1 090 kr",
        "unit": "75 min",
        "icon": "star",
        "price": 1090
      },
      {
        "name": "Idrettsmassasje",
        "description": "Restitusjon før eller etter konkurranse.",
        "priceText": "fra 990 kr",
        "unit": "60 min",
        "icon": "star",
        "price": 990
      },
      {
        "name": "Spa-pakke",
        "description": "Massasje, ansiktsbehandling og hvile.",
        "priceText": "fra 1 890 kr",
        "unit": "120 min",
        "icon": "star",
        "price": 1890
      }
    ]
  },
  {
    "id": "vita",
    "lat": 59.9305,
    "lng": 10.7112,
    "slug": "vita",
    "name": "Vita Helseklinikk",
    "logo": [
      "VITA",
      "HELSEKLINIKK"
    ],
    "mark": "V",
    "industry": "health",
    "city": "Oslo",
    "street": "Sørkedalsveien 8, 0369 Oslo",
    "org_no": "993 447 118",
    "founded": 2009,
    "phone": "22 80 90 00",
    "email": "post@vitaklinikk.no",
    "website": "vitaklinikk.no",
    "opening_hours": "Man–fre 08:00–18:00",
    "tagline": "Fysioterapi, kiropraktikk og allmennhelse under samme tak. Kort ventetid.",
    "from": "690 kr",
    "rating": 4.9,
    "reviews": 246,
    "t1": "Din helse.",
    "t2": "Vår prioritet.",
    "eyebrow": "HELSE & BEHANDLING · OSLO",
    "staff_count": 12,
    "services": [
      {
        "name": "Førstegangskonsultasjon",
        "description": "Kartlegging, undersøkelse og plan.",
        "priceText": "fra 990 kr",
        "unit": "45 min",
        "icon": "help",
        "price": 990
      },
      {
        "name": "Oppfølging",
        "description": "Videre behandling etter plan.",
        "priceText": "fra 690 kr",
        "unit": "30 min",
        "icon": "user",
        "price": 690
      },
      {
        "name": "Akuttime",
        "description": "Time samme dag ved behov.",
        "priceText": "fra 1 190 kr",
        "unit": "30 min",
        "icon": "phone",
        "price": 1190
      },
      {
        "name": "Digital konsultasjon",
        "description": "Video med behandler.",
        "priceText": "fra 590 kr",
        "unit": "20 min",
        "icon": "video",
        "price": 590
      }
    ]
  },
  {
    "id": "aktivfys",
    "lat": 59.9138,
    "lng": 10.7418,
    "slug": "aktivfys",
    "name": "Aktiv Fysioterapi",
    "logo": [
      "AKTIV",
      "FYSIOTERAPI"
    ],
    "mark": "A",
    "industry": "health",
    "city": "Oslo",
    "street": "Grensen 12, 0159 Oslo",
    "org_no": "915 774 330",
    "founded": 2015,
    "phone": "22 42 15 15",
    "email": "post@aktivfys.no",
    "website": "aktivfys.no",
    "opening_hours": "Man–fre 07:30–17:00",
    "tagline": "Fysioterapi med driftstilskudd. Vi tar imot både med og uten henvisning.",
    "from": "690 kr",
    "rating": 4.8,
    "reviews": 119,
    "t1": "Din helse.",
    "t2": "Vår prioritet.",
    "eyebrow": "HELSE & BEHANDLING · OSLO",
    "staff_count": 6,
    "services": [
      {
        "name": "Førstegangskonsultasjon",
        "description": "Kartlegging, undersøkelse og plan.",
        "priceText": "fra 990 kr",
        "unit": "45 min",
        "icon": "help",
        "price": 990
      },
      {
        "name": "Oppfølging",
        "description": "Videre behandling etter plan.",
        "priceText": "fra 690 kr",
        "unit": "30 min",
        "icon": "user",
        "price": 690
      },
      {
        "name": "Akuttime",
        "description": "Time samme dag ved behov.",
        "priceText": "fra 1 190 kr",
        "unit": "30 min",
        "icon": "phone",
        "price": 1190
      },
      {
        "name": "Digital konsultasjon",
        "description": "Video med behandler.",
        "priceText": "fra 590 kr",
        "unit": "20 min",
        "icon": "video",
        "price": 590
      }
    ]
  },
  {
    "id": "balansek",
    "lat": 60.391,
    "lng": 5.326,
    "slug": "balansek",
    "name": "Balanse Kiropraktikk",
    "logo": [
      "BALANSE",
      "KIROPRAKTIKK"
    ],
    "mark": "B",
    "industry": "health",
    "city": "Bergen",
    "street": "Christies gate 5, 5015 Bergen",
    "org_no": "996 004 887",
    "founded": 2011,
    "phone": "55 31 44 00",
    "email": "post@balansek.no",
    "website": "balansek.no",
    "opening_hours": "Man–fre 08:00–17:00",
    "tagline": "Kiropraktikk og bevegelsesterapi. Undersøkelse og behandling i samme time.",
    "from": "790 kr",
    "rating": 4.7,
    "reviews": 93,
    "t1": "Din helse.",
    "t2": "Vår prioritet.",
    "eyebrow": "HELSE & BEHANDLING · BERGEN",
    "staff_count": 4,
    "services": [
      {
        "name": "Førstegangskonsultasjon",
        "description": "Kartlegging, undersøkelse og plan.",
        "priceText": "fra 990 kr",
        "unit": "45 min",
        "icon": "help",
        "price": 990
      },
      {
        "name": "Oppfølging",
        "description": "Videre behandling etter plan.",
        "priceText": "fra 690 kr",
        "unit": "30 min",
        "icon": "user",
        "price": 690
      },
      {
        "name": "Akuttime",
        "description": "Time samme dag ved behov.",
        "priceText": "fra 1 190 kr",
        "unit": "30 min",
        "icon": "phone",
        "price": 1190
      },
      {
        "name": "Digital konsultasjon",
        "description": "Video med behandler.",
        "priceText": "fra 590 kr",
        "unit": "20 min",
        "icon": "video",
        "price": 590
      }
    ]
  },
  {
    "id": "naerhelse",
    "slug": "naerhelse",
    "name": "Nær Helse Digital",
    "logo": [
      "NÆR",
      "HELSE DIGITAL"
    ],
    "mark": "N",
    "industry": "health",
    "city": "Digitalt",
    "street": "Ingen fysisk resepsjon · post: Postboks 88, 4001 Stavanger",
    "org_no": "927 553 118",
    "founded": 2021,
    "phone": "21 09 88 00",
    "email": "hei@naerhelse.no",
    "website": "naerhelse.no",
    "opening_hours": "Man–søn 07:00–23:00",
    "tagline": "Videokonsultasjon med lege, psykolog og ernæringsfysiolog. Time samme dag.",
    "from": "590 kr",
    "rating": 4.8,
    "reviews": 412,
    "t1": "Din helse.",
    "t2": "Vår prioritet.",
    "eyebrow": "HELSE & BEHANDLING · DIGITALT",
    "staff_count": 14,
    "services": [
      {
        "name": "Førstegangskonsultasjon",
        "description": "Kartlegging, undersøkelse og plan.",
        "priceText": "fra 990 kr",
        "unit": "45 min",
        "icon": "help",
        "price": 990
      },
      {
        "name": "Oppfølging",
        "description": "Videre behandling etter plan.",
        "priceText": "fra 690 kr",
        "unit": "30 min",
        "icon": "user",
        "price": 690
      },
      {
        "name": "Akuttime",
        "description": "Time samme dag ved behov.",
        "priceText": "fra 1 190 kr",
        "unit": "30 min",
        "icon": "phone",
        "price": 1190
      },
      {
        "name": "Digital konsultasjon",
        "description": "Video med behandler.",
        "priceText": "fra 590 kr",
        "unit": "20 min",
        "icon": "video",
        "price": 590
      }
    ]
  },
  {
    "id": "corestudio",
    "lat": 59.9245,
    "lng": 10.758,
    "slug": "corestudio",
    "name": "Core Studio",
    "logo": [
      "CORE",
      "STUDIO"
    ],
    "mark": "C",
    "industry": "training",
    "city": "Oslo",
    "street": "Thorvald Meyers gate 61, 0552 Oslo",
    "org_no": "917 663 004",
    "founded": 2016,
    "phone": "22 90 90 90",
    "email": "post@corestudio.no",
    "website": "corestudio.no",
    "opening_hours": "Man–fre 06:00–22:00, lør–søn 09:00–18:00",
    "tagline": "PT, yoga og småtimer på Grünerløkka. Maks åtte deltakere per gruppetime.",
    "from": "250 kr",
    "rating": 4.8,
    "reviews": 167,
    "t1": "Kom i gang.",
    "t2": "Og hold det gående.",
    "eyebrow": "TRENING & PT · OSLO",
    "staff_count": 11,
    "services": [
      {
        "name": "PT-time",
        "description": "Personlig trening med program.",
        "priceText": "fra 790 kr",
        "unit": "60 min",
        "icon": "user",
        "price": 790
      },
      {
        "name": "Prøvetime",
        "description": "Uforpliktende kartlegging og testtime.",
        "priceText": "Gratis",
        "unit": "45 min",
        "icon": "help",
        "price": null
      },
      {
        "name": "Gruppetime",
        "description": "Styrke, kondisjon eller yoga.",
        "priceText": "fra 250 kr",
        "unit": "60 min",
        "icon": "users",
        "price": 250
      },
      {
        "name": "Klippekort 10",
        "description": "Ti PT-timer med rabatt.",
        "priceText": "fra 6 900 kr",
        "unit": "10 timer",
        "icon": "star",
        "price": 6900
      }
    ]
  },
  {
    "id": "styrkelab",
    "lat": 59.9147,
    "lng": 10.79,
    "slug": "styrkelab",
    "name": "Styrkelab",
    "logo": [
      "STYRKELAB",
      "TRENING & PT"
    ],
    "mark": "S",
    "industry": "training",
    "city": "Oslo",
    "street": "Ensjøveien 20, 0661 Oslo",
    "org_no": "920 887 441",
    "founded": 2018,
    "phone": "22 68 30 30",
    "email": "hei@styrkelab.no",
    "website": "styrkelab.no",
    "opening_hours": "Man–fre 05:30–22:00, lør 09:00–16:00",
    "tagline": "Styrketrening med testing og program. Egen sone for tunge løft.",
    "from": "790 kr",
    "rating": 4.9,
    "reviews": 98,
    "t1": "Kom i gang.",
    "t2": "Og hold det gående.",
    "eyebrow": "TRENING & PT · OSLO",
    "staff_count": 7,
    "services": [
      {
        "name": "PT-time",
        "description": "Personlig trening med program.",
        "priceText": "fra 790 kr",
        "unit": "60 min",
        "icon": "user",
        "price": 790
      },
      {
        "name": "Prøvetime",
        "description": "Uforpliktende kartlegging og testtime.",
        "priceText": "Gratis",
        "unit": "45 min",
        "icon": "help",
        "price": null
      },
      {
        "name": "Gruppetime",
        "description": "Styrke, kondisjon eller yoga.",
        "priceText": "fra 250 kr",
        "unit": "60 min",
        "icon": "users",
        "price": 250
      },
      {
        "name": "Klippekort 10",
        "description": "Ti PT-timer med rabatt.",
        "priceText": "fra 6 900 kr",
        "unit": "10 timer",
        "icon": "star",
        "price": 6900
      }
    ]
  },
  {
    "id": "flytyoga",
    "lat": 60.392,
    "lng": 5.3195,
    "slug": "flytyoga",
    "name": "Flyt Yoga",
    "logo": [
      "FLYT",
      "YOGA"
    ],
    "mark": "F",
    "industry": "training",
    "city": "Bergen",
    "street": "Vaskerelven 8, 5014 Bergen",
    "org_no": "914 220 663",
    "founded": 2014,
    "phone": "55 96 20 20",
    "email": "post@flytyoga.no",
    "website": "flytyoga.no",
    "opening_hours": "Man–søn 07:00–21:00",
    "tagline": "Yoga og pust for alle nivåer. Første time er alltid gratis.",
    "from": "220 kr",
    "rating": 4.9,
    "reviews": 141,
    "t1": "Kom i gang.",
    "t2": "Og hold det gående.",
    "eyebrow": "TRENING & PT · BERGEN",
    "staff_count": 9,
    "services": [
      {
        "name": "PT-time",
        "description": "Personlig trening med program.",
        "priceText": "fra 790 kr",
        "unit": "60 min",
        "icon": "user",
        "price": 790
      },
      {
        "name": "Prøvetime",
        "description": "Uforpliktende kartlegging og testtime.",
        "priceText": "Gratis",
        "unit": "45 min",
        "icon": "help",
        "price": null
      },
      {
        "name": "Gruppetime",
        "description": "Styrke, kondisjon eller yoga.",
        "priceText": "fra 250 kr",
        "unit": "60 min",
        "icon": "users",
        "price": 250
      },
      {
        "name": "Klippekort 10",
        "description": "Ti PT-timer med rabatt.",
        "priceText": "fra 6 900 kr",
        "unit": "10 timer",
        "icon": "star",
        "price": 6900
      }
    ]
  },
  {
    "id": "utept",
    "lat": 63.4245,
    "lng": 10.387,
    "slug": "utept",
    "name": "Ute PT Trondheim",
    "logo": [
      "UTE",
      "PT TRONDHEIM"
    ],
    "mark": "U",
    "industry": "training",
    "city": "Trondheim",
    "street": "Klostergata 60, 7030 Trondheim",
    "org_no": "925 118 774",
    "founded": 2020,
    "phone": "73 88 12 12",
    "email": "hei@utept.no",
    "website": "utept.no",
    "opening_hours": "Man–fre 06:00–20:00, lør 09:00–14:00",
    "tagline": "Personlig trening utendørs hele året. Løping, styrke og intervall.",
    "from": "690 kr",
    "rating": 4.8,
    "reviews": 63,
    "t1": "Kom i gang.",
    "t2": "Og hold det gående.",
    "eyebrow": "TRENING & PT · TRONDHEIM",
    "staff_count": 4,
    "services": [
      {
        "name": "PT-time",
        "description": "Personlig trening med program.",
        "priceText": "fra 790 kr",
        "unit": "60 min",
        "icon": "user",
        "price": 790
      },
      {
        "name": "Prøvetime",
        "description": "Uforpliktende kartlegging og testtime.",
        "priceText": "Gratis",
        "unit": "45 min",
        "icon": "help",
        "price": null
      },
      {
        "name": "Gruppetime",
        "description": "Styrke, kondisjon eller yoga.",
        "priceText": "fra 250 kr",
        "unit": "60 min",
        "icon": "users",
        "price": 250
      },
      {
        "name": "Klippekort 10",
        "description": "Ti PT-timer med rabatt.",
        "priceText": "fra 6 900 kr",
        "unit": "10 timer",
        "icon": "star",
        "price": 6900
      }
    ]
  },
  {
    "id": "sabrura",
    "lat": 59.9159,
    "lng": 10.7504,
    "slug": "sabrura",
    "name": "Brasserie Nordre",
    "logo": [
      "BRASSERIE",
      "NORDRE"
    ],
    "mark": "B",
    "industry": "restaurant",
    "city": "Oslo",
    "street": "Torggata 16, 0181 Oslo",
    "org_no": "998 774 220",
    "founded": 2012,
    "phone": "22 10 20 30",
    "email": "post@brasserienordre.no",
    "website": "brasserienordre.no",
    "opening_hours": "Man–tor 15:00–23:00, fre–lør 14:00–24:00",
    "tagline": "Klassisk brasserie i Torggata. Sesongmeny, bordreservasjon og takeaway.",
    "from": "195 kr",
    "rating": 4.7,
    "reviews": 1284,
    "t1": "Reserver bord.",
    "t2": "Uten telefonkø.",
    "eyebrow": "RESTAURANT & KAFÉ · OSLO",
    "staff_count": 24,
    "services": [
      {
        "name": "Bordreservasjon",
        "description": "Velg dato, tid og antall gjester.",
        "priceText": "Gratis",
        "unit": "—",
        "icon": "cal",
        "price": null
      },
      {
        "name": "Chef’s menu",
        "description": "Flerretters meny etter sesong.",
        "priceText": "fra 795 kr",
        "unit": "2 t",
        "icon": "star",
        "price": 795
      },
      {
        "name": "Takeaway",
        "description": "Bestill og betal før henting.",
        "priceText": "fra 195 kr",
        "unit": "30 min",
        "icon": "doc",
        "price": 195
      },
      {
        "name": "Selskap",
        "description": "Egen sal for grupper fra 10 personer.",
        "priceText": "Etter tilbud",
        "unit": "—",
        "icon": "users",
        "price": null
      }
    ]
  },
  {
    "id": "bryggen",
    "lat": 60.3971,
    "lng": 5.3243,
    "slug": "bryggen",
    "name": "Bryggen Mat & Vin",
    "logo": [
      "BRYGGEN",
      "MAT & VIN"
    ],
    "mark": "B",
    "industry": "restaurant",
    "city": "Bergen",
    "street": "Bryggen 11, 5003 Bergen",
    "org_no": "989 663 118",
    "founded": 2006,
    "phone": "55 30 20 10",
    "email": "post@bryggenmat.no",
    "website": "bryggenmat.no",
    "opening_hours": "Tir–søn 16:00–23:00",
    "tagline": "Sesongmeny med råvarer fra Vestlandet. Egen sal for selskap.",
    "from": "395 kr",
    "rating": 4.8,
    "reviews": 892,
    "t1": "Reserver bord.",
    "t2": "Uten telefonkø.",
    "eyebrow": "RESTAURANT & KAFÉ · BERGEN",
    "staff_count": 31,
    "services": [
      {
        "name": "Bordreservasjon",
        "description": "Velg dato, tid og antall gjester.",
        "priceText": "Gratis",
        "unit": "—",
        "icon": "cal",
        "price": null
      },
      {
        "name": "Chef’s menu",
        "description": "Flerretters meny etter sesong.",
        "priceText": "fra 795 kr",
        "unit": "2 t",
        "icon": "star",
        "price": 795
      },
      {
        "name": "Takeaway",
        "description": "Bestill og betal før henting.",
        "priceText": "fra 195 kr",
        "unit": "30 min",
        "icon": "doc",
        "price": 195
      },
      {
        "name": "Selskap",
        "description": "Egen sal for grupper fra 10 personer.",
        "priceText": "Etter tilbud",
        "unit": "—",
        "icon": "users",
        "price": null
      }
    ]
  },
  {
    "id": "kafenord",
    "lat": 63.431,
    "lng": 10.3945,
    "slug": "kafenord",
    "name": "Pizzeria Nord",
    "logo": [
      "PIZZERIA",
      "NORD"
    ],
    "mark": "P",
    "industry": "restaurant",
    "city": "Trondheim",
    "street": "Munkegata 26, 7011 Trondheim",
    "org_no": "918 004 553",
    "founded": 2017,
    "phone": "73 51 60 60",
    "email": "hei@pizzerianord.no",
    "website": "pizzerianord.no",
    "opening_hours": "Man–tor 15:00–22:00, fre–lør 14:00–23:00",
    "tagline": "Napolitansk pizza fra vedfyrt ovn, midt i byen. Åpent kjøkken og korte ventetider.",
    "from": "189 kr",
    "rating": 4.6,
    "reviews": 437,
    "t1": "Reserver bord.",
    "t2": "Uten telefonkø.",
    "eyebrow": "RESTAURANT & KAFÉ · TRONDHEIM",
    "staff_count": 12,
    "services": [
      {
        "name": "Bordreservasjon",
        "description": "Velg dato, tid og antall gjester.",
        "priceText": "Gratis",
        "unit": "—",
        "icon": "cal",
        "price": null
      },
      {
        "name": "Chef’s menu",
        "description": "Flerretters meny etter sesong.",
        "priceText": "fra 795 kr",
        "unit": "2 t",
        "icon": "star",
        "price": 795
      },
      {
        "name": "Takeaway",
        "description": "Bestill og betal før henting.",
        "priceText": "fra 195 kr",
        "unit": "30 min",
        "icon": "doc",
        "price": 195
      },
      {
        "name": "Selskap",
        "description": "Egen sal for grupper fra 10 personer.",
        "priceText": "Etter tilbud",
        "unit": "—",
        "icon": "users",
        "price": null
      }
    ]
  },
  {
    "id": "fjordbord",
    "lat": 58.972,
    "lng": 5.735,
    "slug": "fjordbord",
    "name": "Fjordbord Stavanger",
    "logo": [
      "FJORDBORD",
      "STAVANGER"
    ],
    "mark": "F",
    "industry": "restaurant",
    "city": "Stavanger",
    "street": "Skagen 18, 4006 Stavanger",
    "org_no": "923 447 006",
    "founded": 2019,
    "phone": "51 84 10 10",
    "email": "post@fjordbord.no",
    "website": "fjordbord.no",
    "opening_hours": "Ons–søn 17:00–23:00",
    "tagline": "Sjømat fra dagens fangst. Flerretters meny etter sesong.",
    "from": "445 kr",
    "rating": 4.9,
    "reviews": 311,
    "t1": "Reserver bord.",
    "t2": "Uten telefonkø.",
    "eyebrow": "RESTAURANT & KAFÉ · STAVANGER",
    "staff_count": 18,
    "services": [
      {
        "name": "Bordreservasjon",
        "description": "Velg dato, tid og antall gjester.",
        "priceText": "Gratis",
        "unit": "—",
        "icon": "cal",
        "price": null
      },
      {
        "name": "Chef’s menu",
        "description": "Flerretters meny etter sesong.",
        "priceText": "fra 795 kr",
        "unit": "2 t",
        "icon": "star",
        "price": 795
      },
      {
        "name": "Takeaway",
        "description": "Bestill og betal før henting.",
        "priceText": "fra 195 kr",
        "unit": "30 min",
        "icon": "doc",
        "price": 195
      },
      {
        "name": "Selskap",
        "description": "Egen sal for grupper fra 10 personer.",
        "priceText": "Etter tilbud",
        "unit": "—",
        "icon": "users",
        "price": null
      }
    ]
  },
  {
    "id": "nordichome",
    "lat": 59.921,
    "lng": 10.679,
    "slug": "nordichome",
    "name": "Nordic Home Service",
    "logo": [
      "NORDIC",
      "HOME SERVICE"
    ],
    "mark": "N",
    "industry": "home",
    "city": "Oslo",
    "street": "Nedre Skøyen vei 24, 0276 Oslo",
    "org_no": "912 220 887",
    "founded": 2013,
    "phone": "40 70 70 70",
    "email": "post@nordichome.no",
    "website": "nordichome.no",
    "opening_hours": "Man–fre 07:00–17:00",
    "tagline": "Hage, pool og utvendig vedlikehold. Fast serviceplan eller enkeltoppdrag.",
    "from": "990 kr",
    "rating": 4.9,
    "reviews": 318,
    "t1": "Fagfolk hjem",
    "t2": "til deg.",
    "eyebrow": "HJEM & SERVICE · OSLO",
    "staff_count": 22,
    "services": [
      {
        "name": "Befaring",
        "description": "Vurdering på stedet og skriftlig tilbud.",
        "priceText": "Gratis",
        "unit": "60 min",
        "icon": "pin",
        "price": null
      },
      {
        "name": "Fast avtale",
        "description": "Ukentlig eller månedlig service.",
        "priceText": "fra 990 kr",
        "unit": "per gang",
        "icon": "cal",
        "price": 990
      },
      {
        "name": "Enkeltoppdrag",
        "description": "Avtalt jobb med fast pris.",
        "priceText": "Etter tilbud",
        "unit": "—",
        "icon": "doc",
        "price": null
      },
      {
        "name": "Akutt utrykning",
        "description": "Vann- eller brannskade, døgnvakt.",
        "priceText": "fra 2 490 kr",
        "unit": "utrykning",
        "icon": "phone",
        "price": 2490
      }
    ]
  },
  {
    "id": "skadestopp",
    "lat": 59.928,
    "lng": 10.803,
    "slug": "skadestopp",
    "name": "Skadestopp Døgnvakt",
    "logo": [
      "SKADESTOPP",
      "DØGNVAKT"
    ],
    "mark": "S",
    "industry": "restoration",
    "city": "Oslo",
    "street": "Kabelgaten 8, 0580 Oslo",
    "org_no": "995 663 441",
    "founded": 2010,
    "phone": "40 20 30 40",
    "email": "vakt@skadestopp.no",
    "website": "skadestopp.no",
    "opening_hours": "Døgnvakt, alle dager",
    "tagline": "Vann-, brann- og fuktskade. Døgnvakt i Oslo og Viken, utrykning innen to timer.",
    "from": "2 490 kr",
    "rating": 4.8,
    "reviews": 206,
    "t1": "Fagfolk hjem",
    "t2": "til deg.",
    "eyebrow": "HJEM & SERVICE · OSLO",
    "staff_count": 34,
    "services": [
      {
        "name": "Befaring",
        "description": "Vurdering på stedet og skriftlig tilbud.",
        "priceText": "Gratis",
        "unit": "60 min",
        "icon": "pin",
        "price": null
      },
      {
        "name": "Fast avtale",
        "description": "Ukentlig eller månedlig service.",
        "priceText": "fra 990 kr",
        "unit": "per gang",
        "icon": "cal",
        "price": 990
      },
      {
        "name": "Enkeltoppdrag",
        "description": "Avtalt jobb med fast pris.",
        "priceText": "Etter tilbud",
        "unit": "—",
        "icon": "doc",
        "price": null
      },
      {
        "name": "Akutt utrykning",
        "description": "Vann- eller brannskade, døgnvakt.",
        "priceText": "fra 2 490 kr",
        "unit": "utrykning",
        "icon": "phone",
        "price": 2490
      }
    ]
  },
  {
    "id": "cleanshine",
    "lat": 59.933,
    "lng": 10.809,
    "slug": "cleanshine",
    "name": "Clean & Shine",
    "logo": [
      "CLEAN",
      "& SHINE"
    ],
    "mark": "C",
    "industry": "cleaning",
    "city": "Oslo",
    "street": "Økernveien 145, 0580 Oslo",
    "org_no": "915 887 220",
    "founded": 2015,
    "phone": "40 88 80 00",
    "email": "post@cleanshine.no",
    "website": "cleanshine.no",
    "opening_hours": "Man–fre 07:00–19:00, lør 09:00–15:00",
    "tagline": "Hjemmerengjøring og flyttevask med garanti. Godkjent av Arbeidstilsynet.",
    "from": "1 490 kr",
    "rating": 4.7,
    "reviews": 512,
    "t1": "Fagfolk hjem",
    "t2": "til deg.",
    "eyebrow": "HJEM & SERVICE · OSLO",
    "staff_count": 41,
    "services": [
      {
        "name": "Befaring",
        "description": "Vurdering på stedet og skriftlig tilbud.",
        "priceText": "Gratis",
        "unit": "60 min",
        "icon": "pin",
        "price": null
      },
      {
        "name": "Fast avtale",
        "description": "Ukentlig eller månedlig service.",
        "priceText": "fra 990 kr",
        "unit": "per gang",
        "icon": "cal",
        "price": 990
      },
      {
        "name": "Enkeltoppdrag",
        "description": "Avtalt jobb med fast pris.",
        "priceText": "Etter tilbud",
        "unit": "—",
        "icon": "doc",
        "price": null
      },
      {
        "name": "Akutt utrykning",
        "description": "Vann- eller brannskade, døgnvakt.",
        "priceText": "fra 2 490 kr",
        "unit": "utrykning",
        "icon": "phone",
        "price": 2490
      }
    ]
  },
  /* A heat pump firm: a speciality of the trades rather than a trade of its
     own — see `parent` in industries/index.js. Its organisation number is
     deliberately empty, so this business is not published until somebody
     supplies a real one. See the note inside the record. */
  {
    "id": "klimavarme",
    "lat": 59.9496,
    "lng": 10.762,
    "slug": "klimavarme",
    "name": "Klima & Varme AS",
    "logo": [
      "KLIMA",
      "& VARME"
    ],
    "mark": "K",
    "industry": "heating",
    "city": "Oslo",
    "street": "Ulvenveien 92, 0581 Oslo",
    "org_no": "",
    "demo": true,
    "founded": 2011,
    "phone": "22 40 50 60",
    "email": "post@klimavarme.no",
    "website": "klimavarme.no",
    "opening_hours": "Man–fre 07:00–16:00",
    "tagline": "Varmepumpe, ventilasjon og kjøling. Befaring og skriftlig tilbud før noe bores.",
    "from": "Etter tilbud",
    "rating": 4.8,
    "reviews": 196,
    "t1": "Et varmt hus.",
    "t2": "En skriftlig pris.",
    "eyebrow": "VENTILASJON & VARME · OSLO",
    "staff_count": 14,
    "services": [
      {
        "name": "Befaring",
        "description": "Vi ser på boligen og gir skriftlig pris.",
        "priceText": "Gratis",
        "unit": "45 min",
        "icon": "pin",
        "price": null
      },
      {
        "name": "Montering luft-til-luft",
        "description": "Rør, brakett, igangkjøring og opplæring.",
        "priceText": "Etter tilbud",
        "unit": "—",
        "icon": "doc",
        "price": null
      },
      {
        "name": "Luft-til-vann",
        "description": "Mot vannbåren varme. Krever befaring.",
        "priceText": "Etter tilbud",
        "unit": "—",
        "icon": "doc",
        "price": null
      },
      {
        "name": "Balansert ventilasjon",
        "description": "Aggregat, kanaler og innregulering.",
        "priceText": "Etter tilbud",
        "unit": "—",
        "icon": "doc",
        "price": null
      },
      {
        "name": "Årlig service",
        "description": "Rens av filter og kontroll av kuldemedium.",
        "priceText": "fra 1 490 kr",
        "unit": "per gang",
        "icon": "cal",
        "price": 1490
      }
    ]
  },
  {
    "id": "byggservice",
    "lat": 59.9345,
    "lng": 10.8155,
    "slug": "byggservice",
    "name": "Oslo Byggservice",
    "logo": [
      "OSLO",
      "BYGGSERVICE"
    ],
    "mark": "O",
    "industry": "home",
    "city": "Oslo",
    "street": "Brobekkveien 80, 0582 Oslo",
    "org_no": "987 441 663",
    "founded": 2004,
    "phone": "40 20 30 40",
    "email": "post@oslobyggservice.no",
    "website": "oslobyggservice.no",
    "opening_hours": "Man–fre 07:00–16:00",
    "tagline": "Snekker, maler og elektriker i ett. Befaring og skriftlig tilbud før oppstart.",
    "from": "Etter tilbud",
    "rating": 4.9,
    "reviews": 274,
    "t1": "Fagfolk hjem",
    "t2": "til deg.",
    "eyebrow": "HJEM & SERVICE · OSLO",
    "staff_count": 28,
    "services": [
      {
        "name": "Befaring",
        "description": "Vurdering på stedet og skriftlig tilbud.",
        "priceText": "Gratis",
        "unit": "60 min",
        "icon": "pin",
        "price": null
      },
      {
        "name": "Fast avtale",
        "description": "Ukentlig eller månedlig service.",
        "priceText": "fra 990 kr",
        "unit": "per gang",
        "icon": "cal",
        "price": 990
      },
      {
        "name": "Enkeltoppdrag",
        "description": "Avtalt jobb med fast pris.",
        "priceText": "Etter tilbud",
        "unit": "—",
        "icon": "doc",
        "price": null
      },
      {
        "name": "Akutt utrykning",
        "description": "Vann- eller brannskade, døgnvakt.",
        "priceText": "fra 2 490 kr",
        "unit": "utrykning",
        "icon": "phone",
        "price": 2490
      }
    ]
  },
  {
    "id": "hovden",
    "lat": 59.9276,
    "lng": 10.7156,
    "slug": "hovden",
    "name": "Hovden & Strand Advokatfirma",
    "logo": [
      "HOVDEN",
      "& STRAND"
    ],
    "mark": "H",
    "industry": "legal",
    "city": "Oslo",
    "street": "Bogstadveien 27 B, 0355 Oslo",
    "org_no": "986 402 118",
    "founded": 1998,
    "phone": "22 11 22 33",
    "email": "post@hovdenstrand.no",
    "website": "hovdenstrand.no",
    "opening_hours": "Man–fre 08:30–16:30",
    "tagline": "Familierett, arv og fast eiendom for privatpersoner. Samme advokat følger saken fra første samtale til den er avsluttet.",
    "from": "",
    "rating": 4.9,
    "reviews": 214,
    "t1": "Din sak.",
    "t2": "Vår fulle oppmerksomhet.",
    "eyebrow": "ADVOKATFIRMA I OSLO SIDEN 1998",
    "staff_count": 6,
    "services": [
      {
        "name": "Innledende samtale",
        "description": "Uforpliktende avklaring av saken din.",
        "priceText": "Gratis",
        "unit": "15 min",
        "icon": "help",
        "price": null
      },
      {
        "name": "Rådgivning",
        "description": "Løpende bistand, faktureres per påbegynte 15 minutter.",
        "priceText": "fra 1 890 kr",
        "unit": "per time",
        "icon": "scale",
        "price": 1890
      },
      {
        "name": "Skifteoppdrag",
        "description": "Bistand ved dødsbo, uskifte og arveoppgjør.",
        "priceText": "fra 12 500 kr",
        "unit": "fastpris",
        "icon": "doc",
        "price": 12500
      },
      {
        "name": "Prosessoppdrag",
        "description": "Bistand for tingrett og lagmannsrett.",
        "priceText": "Etter avtale",
        "unit": "per time",
        "icon": "book",
        "price": null
      }
    ]
  },
  {
    "id": "sandberg",
    "lat": 59.9139,
    "lng": 10.7522,
    "slug": "sandberg",
    "name": "Sandberg Digital Advokat",
    "logo": [
      "SANDBERG",
      "DIGITAL ADVOKAT"
    ],
    "mark": "S",
    "industry": "legal",
    "city": "Digitalt",
    "street": "Ingen fysisk resepsjon · post: Postboks 412 Sentrum, 0103 Oslo",
    "org_no": "927 118 640",
    "founded": 2021,
    "phone": "21 09 44 00",
    "email": "hei@sandbergdigital.no",
    "website": "sandbergdigital.no",
    "opening_hours": "Man–fre 07:00–21:00, lør 10:00–14:00",
    "tagline": "Et heldigitalt advokatkontor. Ingen resepsjon, ingen ventetid — du snakker med advokat i dag, uansett hvor i landet du bor.",
    "from": "",
    "rating": 4.8,
    "reviews": 486,
    "t1": "Advokat i dag.",
    "t2": "Uansett hvor du er.",
    "eyebrow": "NEOKONTOR · HELE NORGE",
    "staff_count": 4,
    "services": [
      {
        "name": "Telefonrådgivning",
        "description": "Snakk med advokat nå. Du betaler kun for minuttene du bruker.",
        "priceText": "39 kr/min",
        "unit": "ingen startpris",
        "icon": "phone",
        "price": 39
      },
      {
        "name": "Sluttavtale-sjekk",
        "description": "Gjennomgang av tilbudt sluttavtale med skriftlig svar innen 24 t.",
        "priceText": "2 900 kr",
        "unit": "fastpris",
        "icon": "doc",
        "price": 2900
      },
      {
        "name": "Oppsigelsessak",
        "description": "Forhandling og eventuell rettslig prosess.",
        "priceText": "fra 1 490 kr",
        "unit": "per time",
        "icon": "scale",
        "price": 1490
      },
      {
        "name": "Kontraktgjennomgang",
        "description": "Arbeidsavtale, oppdragsavtale eller forbrukerkontrakt.",
        "priceText": "1 900 kr",
        "unit": "fastpris",
        "icon": "book",
        "price": 1900
      }
    ]
  },
  {
    "id": "nordvik",
    "lat": 60.3925,
    "lng": 5.3242,
    "slug": "nordvik",
    "name": "Nordvik & Partners",
    "logo": [
      "NORDVIK",
      "& PARTNERS"
    ],
    "mark": "N",
    "industry": "legal",
    "city": "Bergen",
    "street": "Torgallmenningen 8, 5014 Bergen · Kongens gate 11, 7011 Trondheim",
    "org_no": "914 776 205",
    "founded": 1984,
    "phone": "55 30 10 00",
    "email": "firmapost@nordvikpartners.no",
    "website": "nordvikpartners.no",
    "opening_hours": "Man–fre 08:00–16:00",
    "tagline": "Et av Vestlandets eldste advokatkontorer. Prosedyre, selskapsrett og arv — med kontorer i Bergen og Trondheim og digital oppfølging.",
    "from": "",
    "rating": 4.7,
    "reviews": 158,
    "t1": "Erfaring som",
    "t2": "holder i retten.",
    "eyebrow": "BERGEN OG TRONDHEIM SIDEN 1984",
    "staff_count": 11,
    "services": [
      {
        "name": "Førstekonsultasjon",
        "description": "30 minutter med konkret svar og skriftlig oppsummering.",
        "priceText": "990 kr",
        "unit": "30 min",
        "icon": "help",
        "price": 990
      },
      {
        "name": "Arveoppgjør",
        "description": "Skifte, uskifte og testament.",
        "priceText": "fra 1 990 kr",
        "unit": "per time",
        "icon": "doc",
        "price": 1990
      },
      {
        "name": "Selskapsrett",
        "description": "Struktur, styreansvar og transaksjoner.",
        "priceText": "fra 2 150 kr",
        "unit": "per time",
        "icon": "book",
        "price": 2150
      },
      {
        "name": "Prosedyre",
        "description": "Tingrett, lagmannsrett og Høyesterett.",
        "priceText": "Etter avtale",
        "unit": "per time",
        "icon": "scale",
        "price": null
      }
    ]
  },
  {
    "id": "bakke",
    "lat": 59.9096,
    "lng": 10.7418,
    "slug": "bakke",
    "name": "Bakke Revisjon",
    "logo": [
      "BAKKE",
      "REVISJON"
    ],
    "mark": "B",
    "industry": "accounting",
    "city": "Oslo",
    "street": "Rådhusgata 17, 0158 Oslo",
    "org_no": "989 331 447",
    "founded": 2006,
    "phone": "22 33 44 55",
    "email": "post@bakkerevisjon.no",
    "website": "bakkerevisjon.no",
    "opening_hours": "Man–fre 08:00–16:00",
    "tagline": "Revisjon og økonomisk rådgivning for AS med 1–50 ansatte. Fast kontaktperson gjennom hele året.",
    "from": "",
    "rating": 4.9,
    "reviews": 87,
    "t1": "Tallene på plass.",
    "t2": "Hele året.",
    "eyebrow": "STATSAUTORISERT REVISOR I OSLO",
    "staff_count": 5,
    "services": [
      {
        "name": "Innledende møte",
        "description": "20 minutters kartlegging av behovet.",
        "priceText": "Gratis",
        "unit": "20 min",
        "icon": "help",
        "price": null
      },
      {
        "name": "Revisjon",
        "description": "Årsregnskap, beretning og innlevering.",
        "priceText": "fra 1 450 kr",
        "unit": "per time",
        "icon": "doc",
        "price": 1450
      },
      {
        "name": "Verdivurdering",
        "description": "Underlag ved salg, fisjon eller emisjon.",
        "priceText": "Etter avtale",
        "unit": "prosjekt",
        "icon": "book",
        "price": null
      }
    ]
  },
  {
    "id": "vold",
    "lat": 59.9105,
    "lng": 10.7648,
    "slug": "vold",
    "name": "Vold Arkitektur",
    "logo": [
      "VOLD",
      "ARKITEKTUR"
    ],
    "mark": "V",
    "industry": "architect",
    "city": "Oslo",
    "street": "Schweigaards gate 34, 0191 Oslo",
    "org_no": "913 220 887",
    "founded": 2014,
    "phone": "22 44 55 66",
    "email": "post@voldark.no",
    "website": "voldark.no",
    "opening_hours": "Man–fre 08:30–16:00",
    "tagline": "Fra skisse til godkjent byggesøknad. Tilbud gis etter gratis befaring eller videomøte.",
    "from": "",
    "rating": 4.8,
    "reviews": 52,
    "t1": "Fra idé",
    "t2": "til byggetillatelse.",
    "eyebrow": "SIVILARKITEKT MNAL · OSLO OG VIKEN",
    "staff_count": 4,
    "services": [
      {
        "name": "Befaring",
        "description": "Vurdering på stedet og muntlig tilbakemelding.",
        "priceText": "Gratis",
        "unit": "60 min",
        "icon": "pin",
        "price": null
      },
      {
        "name": "Skisseprosjekt",
        "description": "Utkast, volumstudie og kostnadsindikasjon.",
        "priceText": "Etter tilbud",
        "unit": "prosjekt",
        "icon": "book",
        "price": null
      },
      {
        "name": "Byggesøknad",
        "description": "Komplett søknad til kommunen med ansvarsrett.",
        "priceText": "Etter tilbud",
        "unit": "prosjekt",
        "icon": "doc",
        "price": null
      }
    ]
  },
  {
    "id": "ravn",
    "lat": 59.9227,
    "lng": 10.794,
    "slug": "ravn",
    "name": "Ravn Teknisk",
    "logo": [
      "RAVN",
      "TEKNISK"
    ],
    "mark": "R",
    "industry": "engineer",
    "city": "Oslo",
    "street": "Grenseveien 92, 0663 Oslo",
    "org_no": "998 442 019",
    "founded": 2012,
    "phone": "22 55 66 77",
    "email": "post@ravnteknisk.no",
    "website": "ravnteknisk.no",
    "opening_hours": "Man–fre 08:00–16:00",
    "tagline": "Konstruksjons-, brann- og energiteknisk rådgivning for boligprosjekter og mindre næringsbygg.",
    "from": "",
    "rating": 4.9,
    "reviews": 41,
    "t1": "Riktig råd",
    "t2": "før du bygger.",
    "eyebrow": "RÅDGIVENDE INGENIØR · OSLO",
    "staff_count": 3,
    "services": [
      {
        "name": "Innledende samtale",
        "description": "15 minutters avklaring av behovet.",
        "priceText": "Gratis",
        "unit": "15 min",
        "icon": "help",
        "price": null
      },
      {
        "name": "Teknisk vurdering",
        "description": "Beregning og kort notat.",
        "priceText": "fra 1 290 kr",
        "unit": "per time",
        "icon": "scale",
        "price": 1290
      },
      {
        "name": "Rapport",
        "description": "Dokumentasjon til byggesak, med leveringsdato i avtalen.",
        "priceText": "Etter tilbud",
        "unit": "prosjekt",
        "icon": "doc",
        "price": null
      }
    ]
  }
];

/** Staff per business id. An empty list is a valid answer. */
export const STAFF = {
  "lykke": [
    {
      "name": "Marte Sandberg",
      "role": "Frisør"
    },
    {
      "name": "Ida Nilsen",
      "role": "Fargespesialist"
    },
    {
      "name": "Oskar Lie",
      "role": "Frisør"
    }
  ],
  "northbarber": [
    {
      "name": "Aleks Rud",
      "role": "Barber"
    },
    {
      "name": "Noah Berg",
      "role": "Barber"
    },
    {
      "name": "Lucas Haugen",
      "role": "Barber"
    }
  ],
  "stilhus": [
    {
      "name": "Vilde Aas",
      "role": "Fargespesialist"
    },
    {
      "name": "Emma Dahl",
      "role": "Frisør"
    },
    {
      "name": "Sander Moe",
      "role": "Frisør"
    }
  ],
  "klipperiet": [
    {
      "name": "Kari Foss",
      "role": "Frisør"
    },
    {
      "name": "Jonas Lund",
      "role": "Frisør"
    },
    {
      "name": "Nora Vik",
      "role": "Frisør"
    }
  ],
  "atelier": [
    {
      "name": "Mia Moe",
      "role": "Behandler"
    },
    {
      "name": "Emma Lie",
      "role": "Behandler"
    },
    {
      "name": "Mia Foss",
      "role": "Behandler"
    },
    {
      "name": "Emma Dahl",
      "role": "Behandler"
    },
    {
      "name": "Ella Berg",
      "role": "Behandler"
    },
    {
      "name": "Petter Solberg",
      "role": "Behandler"
    }
  ],
  "skinclinic": [
    {
      "name": "Liv Nordby",
      "role": "Behandler"
    },
    {
      "name": "Jonas Foss",
      "role": "Behandler"
    },
    {
      "name": "Henrik Aas",
      "role": "Behandler"
    },
    {
      "name": "Jonas Moe",
      "role": "Behandler"
    },
    {
      "name": "Henrik Lund",
      "role": "Behandler"
    }
  ],
  "luxenails": [
    {
      "name": "Henrik Aas",
      "role": "Behandler"
    },
    {
      "name": "Jonas Moe",
      "role": "Behandler"
    },
    {
      "name": "Kristian Dahl",
      "role": "Behandler"
    },
    {
      "name": "Hanne Haugen",
      "role": "Behandler"
    },
    {
      "name": "Liv Solberg",
      "role": "Behandler"
    },
    {
      "name": "Live Vik",
      "role": "Behandler"
    }
  ],
  "husetbeauty": [
    {
      "name": "Anna Aas",
      "role": "Behandler"
    },
    {
      "name": "Sara Vik",
      "role": "Behandler"
    },
    {
      "name": "Nora Dahl",
      "role": "Behandler"
    },
    {
      "name": "Sofie Foss",
      "role": "Behandler"
    }
  ],
  "harmony": [
    {
      "name": "Marius Ruud",
      "role": "Terapeut"
    },
    {
      "name": "Anna Lund",
      "role": "Terapeut"
    },
    {
      "name": "Marius Vik",
      "role": "Terapeut"
    },
    {
      "name": "Petter Solberg",
      "role": "Terapeut"
    },
    {
      "name": "Ola Haugen",
      "role": "Terapeut"
    },
    {
      "name": "Petter Nordby",
      "role": "Terapeut"
    }
  ],
  "muskelverk": [
    {
      "name": "Nora Lie",
      "role": "Terapeut"
    },
    {
      "name": "Ella Berg",
      "role": "Terapeut"
    },
    {
      "name": "Nora Dahl",
      "role": "Terapeut"
    },
    {
      "name": "Ella Haugen",
      "role": "Terapeut"
    }
  ],
  "roro": [
    {
      "name": "Hanne Haugen",
      "role": "Terapeut"
    },
    {
      "name": "Liv Nordby",
      "role": "Terapeut"
    },
    {
      "name": "Jonas Moe",
      "role": "Terapeut"
    },
    {
      "name": "Nora Lie",
      "role": "Terapeut"
    },
    {
      "name": "Sara Ruud",
      "role": "Terapeut"
    },
    {
      "name": "Thea Lund",
      "role": "Terapeut"
    }
  ],
  "nordlys": [
    {
      "name": "Henrik Lund",
      "role": "Terapeut"
    },
    {
      "name": "Jonas Foss",
      "role": "Terapeut"
    },
    {
      "name": "Liv Solberg",
      "role": "Terapeut"
    }
  ],
  "vita": [
    {
      "name": "Ola Berg",
      "role": "Behandler"
    },
    {
      "name": "Thea Aas",
      "role": "Behandler"
    },
    {
      "name": "Sofie Foss",
      "role": "Behandler"
    },
    {
      "name": "Henrik Lund",
      "role": "Behandler"
    },
    {
      "name": "Sara Vik",
      "role": "Behandler"
    },
    {
      "name": "Henrik Aas",
      "role": "Behandler"
    }
  ],
  "aktivfys": [
    {
      "name": "Liv Solberg",
      "role": "Behandler"
    },
    {
      "name": "Sara Vik",
      "role": "Behandler"
    },
    {
      "name": "Emma Dahl",
      "role": "Behandler"
    },
    {
      "name": "Sara Ruud",
      "role": "Behandler"
    },
    {
      "name": "Nora Lie",
      "role": "Behandler"
    },
    {
      "name": "Hanne Berg",
      "role": "Behandler"
    }
  ],
  "balansek": [
    {
      "name": "Emma Lund",
      "role": "Behandler"
    },
    {
      "name": "Ola Haugen",
      "role": "Behandler"
    },
    {
      "name": "Henrik Aas",
      "role": "Behandler"
    },
    {
      "name": "Ola Berg",
      "role": "Behandler"
    }
  ],
  "naerhelse": [
    {
      "name": "Anna Lund",
      "role": "Behandler"
    },
    {
      "name": "Marius Ruud",
      "role": "Behandler"
    },
    {
      "name": "Petter Solberg",
      "role": "Behandler"
    },
    {
      "name": "Marius Vik",
      "role": "Behandler"
    },
    {
      "name": "Emma Dahl",
      "role": "Behandler"
    },
    {
      "name": "Ola Haugen",
      "role": "Behandler"
    }
  ],
  "corestudio": [
    {
      "name": "Kristian Dahl",
      "role": "Instruktør"
    },
    {
      "name": "Jonas Foss",
      "role": "Instruktør"
    },
    {
      "name": "Kristian Lie",
      "role": "Instruktør"
    },
    {
      "name": "Live Vik",
      "role": "Instruktør"
    },
    {
      "name": "Petter Nordby",
      "role": "Instruktør"
    },
    {
      "name": "Live Ruud",
      "role": "Instruktør"
    }
  ],
  "styrkelab": [
    {
      "name": "Anna Lund",
      "role": "Instruktør"
    },
    {
      "name": "Marius Ruud",
      "role": "Instruktør"
    },
    {
      "name": "Petter Solberg",
      "role": "Instruktør"
    },
    {
      "name": "Marius Vik",
      "role": "Instruktør"
    },
    {
      "name": "Mia Foss",
      "role": "Instruktør"
    },
    {
      "name": "Anna Aas",
      "role": "Instruktør"
    }
  ],
  "flytyoga": [
    {
      "name": "Anna Aas",
      "role": "Instruktør"
    },
    {
      "name": "Sofie Moe",
      "role": "Instruktør"
    },
    {
      "name": "Nora Dahl",
      "role": "Instruktør"
    },
    {
      "name": "Sofie Foss",
      "role": "Instruktør"
    },
    {
      "name": "Nora Lie",
      "role": "Instruktør"
    },
    {
      "name": "Ella Berg",
      "role": "Instruktør"
    }
  ],
  "utept": [
    {
      "name": "Ella Berg",
      "role": "Instruktør"
    },
    {
      "name": "Anna Aas",
      "role": "Instruktør"
    },
    {
      "name": "Marius Ruud",
      "role": "Instruktør"
    },
    {
      "name": "Anna Lund",
      "role": "Instruktør"
    }
  ],
  "sabrura": [
    {
      "name": "Ola Haugen",
      "role": "Vert"
    },
    {
      "name": "Emma Dahl",
      "role": "Vert"
    },
    {
      "name": "Mia Moe",
      "role": "Vert"
    },
    {
      "name": "Henrik Aas",
      "role": "Vert"
    },
    {
      "name": "Henrik Lund",
      "role": "Vert"
    },
    {
      "name": "Ola Berg",
      "role": "Vert"
    }
  ],
  "bryggen": [
    {
      "name": "Marius Ruud",
      "role": "Vert"
    },
    {
      "name": "Anna Lund",
      "role": "Vert"
    },
    {
      "name": "Marius Vik",
      "role": "Vert"
    },
    {
      "name": "Petter Solberg",
      "role": "Vert"
    },
    {
      "name": "Mia Foss",
      "role": "Vert"
    },
    {
      "name": "Mia Moe",
      "role": "Vert"
    }
  ],
  "kafenord": [
    {
      "name": "Ella Haugen",
      "role": "Vert"
    },
    {
      "name": "Ingrid Nordby",
      "role": "Vert"
    },
    {
      "name": "Ella Berg",
      "role": "Vert"
    },
    {
      "name": "Emma Lie",
      "role": "Vert"
    },
    {
      "name": "Mia Foss",
      "role": "Vert"
    },
    {
      "name": "Anna Lund",
      "role": "Vert"
    }
  ],
  "fjordbord": [
    {
      "name": "Sofie Foss",
      "role": "Vert"
    },
    {
      "name": "Thea Lund",
      "role": "Vert"
    },
    {
      "name": "Sara Vik",
      "role": "Vert"
    },
    {
      "name": "Ingrid Solberg",
      "role": "Vert"
    },
    {
      "name": "Ingrid Nordby",
      "role": "Vert"
    },
    {
      "name": "Sofie Moe",
      "role": "Vert"
    }
  ],
  "nordichome": [
    {
      "name": "Sara Vik",
      "role": "Fagperson"
    },
    {
      "name": "Ingrid Solberg",
      "role": "Fagperson"
    },
    {
      "name": "Sara Ruud",
      "role": "Fagperson"
    },
    {
      "name": "Thea Lund",
      "role": "Fagperson"
    },
    {
      "name": "Sofie Moe",
      "role": "Fagperson"
    },
    {
      "name": "Thea Aas",
      "role": "Fagperson"
    }
  ],
  "skadestopp": [
    {
      "name": "Hanne Berg",
      "role": "Tekniker"
    },
    {
      "name": "Thea Aas",
      "role": "Tekniker"
    },
    {
      "name": "Hanne Haugen",
      "role": "Tekniker"
    },
    {
      "name": "Kristian Dahl",
      "role": "Tekniker"
    },
    {
      "name": "Liv Solberg",
      "role": "Tekniker"
    },
    {
      "name": "Sara Ruud",
      "role": "Tekniker"
    }
  ],
  "cleanshine": [
    {
      "name": "Hanne Haugen",
      "role": "Renholder"
    },
    {
      "name": "Liv Nordby",
      "role": "Renholder"
    },
    {
      "name": "Jonas Moe",
      "role": "Renholder"
    },
    {
      "name": "Nora Lie",
      "role": "Renholder"
    },
    {
      "name": "Sara Ruud",
      "role": "Renholder"
    },
    {
      "name": "Sara Vik",
      "role": "Renholder"
    }
  ],
  "klimavarme": [
    { "name": "Tore Fjeld",     "role": "Montør" },
    { "name": "Aleksander Rud", "role": "Montør" },
    { "name": "Siri Bakken",    "role": "Montør" },
    { "name": "Henrik Aas",     "role": "Serviceteknikker" }
  ],
  "byggservice": [
    {
      "name": "Marius Ruud",
      "role": "Fagperson"
    },
    {
      "name": "Ingrid Nordby",
      "role": "Fagperson"
    },
    {
      "name": "Marius Vik",
      "role": "Fagperson"
    },
    {
      "name": "Emma Lie",
      "role": "Fagperson"
    },
    {
      "name": "Ola Haugen",
      "role": "Fagperson"
    },
    {
      "name": "Emma Dahl",
      "role": "Fagperson"
    }
  ],
  "hovden": [
    {
      "name": "Marius Ruud",
      "role": "Advokat"
    },
    {
      "name": "Anna Lund",
      "role": "Advokat"
    },
    {
      "name": "Marius Vik",
      "role": "Advokat"
    },
    {
      "name": "Petter Solberg",
      "role": "Advokat"
    },
    {
      "name": "Mia Foss",
      "role": "Advokat"
    },
    {
      "name": "Mia Moe",
      "role": "Advokat"
    }
  ],
  "sandberg": [
    {
      "name": "Jonas Foss",
      "role": "Advokat"
    },
    {
      "name": "Henrik Lund",
      "role": "Advokat"
    },
    {
      "name": "Ola Berg",
      "role": "Advokat"
    },
    {
      "name": "Petter Solberg",
      "role": "Advokat"
    }
  ],
  "nordvik": [
    {
      "name": "Emma Lie",
      "role": "Advokat"
    },
    {
      "name": "Sofie Moe",
      "role": "Advokat"
    },
    {
      "name": "Ingrid Nordby",
      "role": "Advokat"
    },
    {
      "name": "Ella Haugen",
      "role": "Advokat"
    },
    {
      "name": "Ingrid Solberg",
      "role": "Advokat"
    },
    {
      "name": "Marius Vik",
      "role": "Advokat"
    }
  ],
  "bakke": [
    {
      "name": "Ola Haugen",
      "role": "Rådgiver"
    },
    {
      "name": "Emma Dahl",
      "role": "Rådgiver"
    },
    {
      "name": "Mia Moe",
      "role": "Rådgiver"
    },
    {
      "name": "Anna Aas",
      "role": "Rådgiver"
    },
    {
      "name": "Marius Ruud",
      "role": "Rådgiver"
    }
  ],
  "vold": [
    {
      "name": "Henrik Aas",
      "role": "Arkitekt"
    },
    {
      "name": "Mia Moe",
      "role": "Arkitekt"
    },
    {
      "name": "Emma Dahl",
      "role": "Arkitekt"
    },
    {
      "name": "Mia Foss",
      "role": "Arkitekt"
    }
  ],
  "ravn": [
    {
      "name": "Thea Lund",
      "role": "Rådgiver"
    },
    {
      "name": "Sofie Foss",
      "role": "Rådgiver"
    },
    {
      "name": "Nora Lie",
      "role": "Rådgiver"
    }
  ]
};

/** Businesses in one industry, in catalogue order. */
export const byIndustry = code => BUSINESSES.filter(b => b.industry === code);

/** One business by id, or by the slug its tail URL uses. */
export const bySlug = slug => BUSINESSES.find(b => b.slug === slug || b.id === slug) || null;
